
























import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import moment from "moment";
import ResourceFormCreate from "@/employer/components/Forms/ResourceFormCreate.vue";
import _ from "lodash";
import {
  UserRoleInt,
  PartnerAssociation,
  ResourceFormDocument,
  ResourceFormDocumentBase,
  ResourceFormDocumentSavePayload
} from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useResourceFormStore } from "@/employer/store/ResourceForm";
import { formDocumentTypeIcon } from "@/shared/awesomeIconMapper";

@Component({
  components: {
    ResourceFormCreate
  }
})
export default class ResourceFormRow extends Vue {
  userStore = useUserStore();
  notifierStore = useNotifierStore();
  resourceFormStore = useResourceFormStore();
  formDocumentTypeIcon = formDocumentTypeIcon;

  moment = moment;
  isOpen = false;
  isSubmitting = false;
  backupData: ResourceFormDocument = null;

  @Prop()
  partnerId: number;

  @Prop()
  resourceForm: ResourceFormDocument;

  get isActive () {
    return this.moment(this.resourceForm.dateAvailableStart) <= this.moment.utc() &&
      (!this.resourceForm.dateAvailableEnd || this.moment.utc() <= this.moment(this.resourceForm.dateAvailableEnd));
  }

  get disabledUpdateButton () {
    return this.isSubmitting || !this.hasWidgetWritePermission;
  }

  get hasWidgetWritePermission () {
    return this.userStore.currentPartner.partnerUserRoles.some(x => x === UserRoleInt.partnerAdmin);
  }

  @Watch("resourceForm")
  onResourceFormChanged (oldVal, newVal) {
    this.backupData = _.cloneDeep(newVal);
  }
  get statusText () {
    return this.isActive ? (this.resourceForm.isOptedOut ? "Opt-out" : "Active") : "Inactive";
  }
  get cssText () {
    return this.isActive ? (this.resourceForm.isOptedOut ? "optout" : "active") : "inactive";
  }

  mounted () {
    this.backupData = _.cloneDeep(this.resourceForm);
  }

  rowClicked () {
    this.isOpen = !this.isOpen;
  }

  onSave (savedResourceForm: ResourceFormDocumentBase) {
    this.isSubmitting = true;
    this.resourceFormStore.saveResourceForm({ partnerId: this.partnerId, resourceForm: savedResourceForm })
      .then(
        _ => {
          this.isSubmitting = false;
          this.isOpen = false;
          this.notifierStore.setSuccess("Form Document Updated", this.notifierStore.shortTimeout);
        }
      )
      .catch(
        err => {
          this.isSubmitting = false;
          this.notifierStore.setDanger("Failed to update form document, please try again.", this.notifierStore.shortTimeout);
        }
      );
  }

  onCancel () {
    this.isOpen = false;
    this.resourceForm.formDocumentId = this.backupData.formDocumentId;
    this.resourceForm.dateAvailableStart = this.backupData.dateAvailableStart;
    this.resourceForm.dateAvailableEnd = this.backupData.dateAvailableEnd;
    this.resourceForm.sellingPartnerIds = this.backupData.sellingPartnerIds;
    this.resourceForm.resourceFormPlanTypes = this.backupData.resourceFormPlanTypes;
    this.resourceForm.employers = this.backupData.employers;
    this.resourceForm.displayName = this.backupData.displayName;
    this.resourceForm.downloadUrl = this.backupData.downloadUrl;
    this.resourceForm.formDocumentType = this.backupData.formDocumentType;
  }

  getEndDate (): string {
    if (!this.resourceForm.dateAvailableEnd) {
      return "";
    } else {
      return moment(this.resourceForm.dateAvailableEnd).format("MMM D, YYYY");
    }
  }
}
